<script lang="ts">
  import type { ImageBlock } from 'query-strapi-v4';
  type Block = $$Generic<ImageBlock | undefined>;
  export let block = undefined as ImageBlock;
  const file = block.media.data.attributes;
  const defaultImage = file;
</script>

{#if block.media}
  <img
    alt={block.media.data.attributes.alternativeText}
    class="my-8 rounded-md border bg-muted transition-colors"
    width={defaultImage.width}
    height={defaultImage.height}
    src={defaultImage.url}
    loading="lazy"
  />
{:else}
  <p>Image not found</p>
{/if}
